import VueRouter from 'vue-router';
import Section from './components/section-component'
import Page from './components/page-component'
import NotFoundComponent from './components/not-found-component'
const _routes = [
    {
        path: '/', 
        redirect: '/de/home'
    },
    {
        path: '/:locale/search',
        redirect: '/de/home'
    },    
    {
        path: '/:locale/:sectionSlug',
        component: Section,
        name: 'section',
        props: (route) => ({ query: route.query.q })
    },
    {
        path: '/:locale/:sectionSlug/:pageSlug',
        component: Page,
        name: 'page'
    },
    {
        path: '*',
        component: NotFoundComponent
    }    
]

var router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: _routes,
    linkActiveClass: 'active'
})

export default router
